import { lazy } from 'react';
import authRoles from '../../../../auth/authRoles';

const IncotermsPage = lazy(() => import('./IncotermsPage'));

const IncotermsPageConfig = {
   settings: {
      layout: {
         config: {},
      },
   },
   auth: authRoles.user,
   routes: [
      {
         path: '/operator/masterdata/incoterms',
         element: <IncotermsPage />,
      },
   ],
};

export default IncotermsPageConfig;
